/**
 * @param {KeyboardEvent} event
 * @returns {boolean}
 */
export function isGlobalSearchShortcut(event) {
  if (!(event.metaKey || event.ctrlKey) || event.key.toLowerCase() !== 'k') {
    return false;
  }
  if (event.altKey || event.shiftKey) {
    return false;
  }
  return true;
}

/**
 * @param {EventTarget | null} target
 * @returns {boolean}
 */
export function isEditableShortcutTarget(target) {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  const tagName = target.tagName?.toLowerCase?.();
  return (
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select' ||
    target.isContentEditable
  );
}

/**
 * @param {EventTarget | null} target
 * @param {boolean} isOpen
 * @returns {boolean} true when the shortcut should be ignored
 */
export function shouldIgnoreGlobalSearchShortcut(target, isOpen) {
  return isEditableShortcutTarget(target) && !isOpen;
}

/**
 * @param {KeyboardEvent} event
 * @returns {boolean}
 */
export function isSlashShortcut(event) {
  return (
    event.key === '/' &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.altKey &&
    !event.shiftKey
  );
}

/**
 * @param {KeyboardEvent} event
 * @param {boolean} isOpen
 * @param {{ onOpen?: () => void, onClose?: () => void }} handlers
 * @returns {boolean} whether the shortcut was handled
 */
export function handleGlobalSearchShortcut(event, isOpen, { onOpen, onClose }) {
  const isK = isGlobalSearchShortcut(event);
  const isSlash = !isOpen && isSlashShortcut(event) && !isEditableShortcutTarget(event.target);

  if (!isK && !isSlash) return false;
  if (isK && shouldIgnoreGlobalSearchShortcut(event.target, isOpen)) return false;

  event.preventDefault();

  if (isOpen) {
    onClose?.();
  } else {
    onOpen?.();
  }

  return true;
}
